/* ------------------------------------------------------------------
   Mobile tap-to-call.

   Two jobs:

   1. NORMALISE every tel: href on the page. The theme's phone_link block
      renders `tel:{{ block.settings.phone_number }}` verbatim, so the stored
      value "(800) 516-2115" produces `tel:(800) 516-2115`. Spaces and
      parentheses are not valid in a tel: URI (RFC 3966); some dialers cope,
      some do not. Rewritten to E.164, `tel:+18005162115`. This also fixes the
      DESKTOP link, which has been shipping malformed.

   2. CLONE the phone link into `#header-toolbar` so it is reachable on
      mobile. It cannot be done in CSS: the block lives inside
      `#header-secondary-nav`, which is `mobile-hidden` (display:none) below
      992px, and no rule on a descendant can reveal it while an ancestor is
      display:none. The node has to move.

   The clone keeps only the icon, not the number text, so the toolbar stays a
   row of glyphs. Styling lives in assets/tcc-overrides.css, which also hides
   the clone at >=992px where the number is already visible in the nav.

   The icon is cloned from the LIVE node rather than rebuilt, because the
   theme renders it through a <load-icon> custom element whose SVG is injected
   at runtime — cloning after render picks up the real markup and needs no
   copy of the path data.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function normaliseTelHrefs() {
    var links = document.querySelectorAll('a[href^="tel:"]');
    for (var i = 0; i < links.length; i++) {
      var raw = links[i].getAttribute('href') || '';
      var digits = raw.slice(4).replace(/[^0-9]/g, '');
      if (!digits) continue;
      if (digits.length === 10) digits = '1' + digits;
      links[i].setAttribute('href', 'tel:+' + digits);
    }
  }

  function addToolbarButton() {
    var toolbar = document.querySelector('[class~="#header-toolbar"]');
    if (!toolbar || toolbar.querySelector('.tcc-call-item')) return;

    var src = document.querySelector('[class~="#main-navigation"] a[href^="tel:"]');
    if (!src) return;

    var icon = src.querySelector('[class*="-item-icon"]');
    if (!icon) return;

    var link = document.createElement('a');
    link.className = 'tcc-call-link';
    link.setAttribute('href', src.getAttribute('href'));
    link.setAttribute('aria-label', 'Call us');
    link.setAttribute('title', src.textContent.replace(/\s+/g, ' ').trim());
    link.appendChild(icon.cloneNode(true));

    var item = document.createElement('div');
    item.className = '#header-toolbar-item tcc-call-item';
    item.appendChild(link);

    // First position, so the cart stays where buyers expect it on the right.
    toolbar.insertBefore(item, toolbar.firstChild);
  }

  function run() {
    normaliseTelHrefs();
    addToolbarButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // <load-icon> injects its SVG asynchronously, so the icon may not exist at
  // DOMContentLoaded. Re-run on added nodes; both steps are idempotent (the
  // .tcc-call-item guard above, and re-normalising an E.164 href is a no-op).
  if (window.MutationObserver) {
    var seen = 0;
    new MutationObserver(function (records, observer) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          run();
          if (++seen > 40) observer.disconnect();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
